// Text after |||| is the plural form, react-admin picks it through smart_count.
export default {
  ra: {
    action: {
      add_filter: 'Dodaj filter',
      add: 'Dodaj',
      back: 'Nazaj',
      bulk_actions: '1 izbran element |||| %{smart_count} izbranih elementov',
      cancel: 'Prekliči',
      clear_input_value: 'Počisti vrednost',
      clone: 'Podvoji',
      confirm: 'Potrdi',
      create: 'Ustvari',
      delete: 'Izbriši',
      edit: 'Uredi',
      export: 'Izvozi',
      list: 'Seznam',
      refresh: 'Osveži',
      remove_filter: 'Odstrani filter',
      remove: 'Odstrani',
      save: 'Shrani',
      search: 'Išči',
      show: 'Prikaži',
      sort: 'Razvrsti',
      undo: 'Razveljavi',
      expand: 'Razširi',
      close: 'Zapri',
    },
    boolean: {
      true: 'Da',
      false: 'Ne',
    },
    page: {
      create: 'Ustvari: %{name}',
      dashboard: 'Nadzorna plošča',
      edit: '%{name} #%{id}',
      error: 'Prišlo je do napake',
      list: '%{name}',
      loading: 'Nalaganje',
      not_found: 'Ni najdeno',
      show: '%{name} #%{id}',
    },
    input: {
      file: {
        upload_several: 'Povlecite datoteke sem ali kliknite za izbiro.',
        upload_single: 'Povlecite datoteko sem ali kliknite za izbiro.',
      },
      image: {
        upload_several: 'Povlecite slike sem ali kliknite za izbiro.',
        upload_single: 'Povlecite sliko sem ali kliknite za izbiro.',
      },
      references: {
        all_missing: 'Povezanih podatkov ni mogoče najti.',
        many_missing: 'Vsaj ena od povezav ni več na voljo.',
        single_missing: 'Povezava ni več na voljo.',
      },
    },
    message: {
      about: 'O aplikaciji',
      are_you_sure: 'Ali ste prepričani?',
      bulk_delete_content:
        'Ali res želite izbrisati ta element? |||| Ali res želite izbrisati teh %{smart_count} elementov?',
      bulk_delete_title: 'Izbriši: %{name} |||| Izbriši %{smart_count} elementov',
      delete_content: 'Ali res želite izbrisati ta element?',
      delete_title: 'Izbriši: %{name} #%{id}',
      details: 'Podrobnosti',
      error: 'Prišlo je do napake, zahteve ni bilo mogoče dokončati.',
      invalid_form: 'Obrazec ni veljaven. Preverite napake.',
      loading: 'Stran se nalaga, počakajte trenutek.',
      no: 'Ne',
      not_found: 'Naslov je napačen ali pa povezava ne deluje.',
      yes: 'Da',
    },
    navigation: {
      no_results: 'Ni rezultatov',
      no_more_results: 'Stran %{page} ne obstaja. Poskusite prejšnjo stran.',
      page_out_of_boundaries: 'Stran %{page} ne obstaja',
      page_out_from_end: 'To je zadnja stran',
      page_out_from_begin: 'To je prva stran',
      page_range_info: '%{offsetBegin}-%{offsetEnd} od %{total}',
      page_rows_per_page: 'Vrstic na stran:',
      next: 'Naprej',
      prev: 'Nazaj',
    },
    auth: {
      user_menu: 'Profil',
      username: 'Uporabniško ime',
      password: 'Geslo',
      sign_in: 'Prijava',
      sign_in_subtitle: 'Vnesite podatke za dostop do računa',
      sign_in_submit: 'Vstopi',
      username_placeholder: 'Vaše uporabniško ime',
      password_placeholder: 'Vaše geslo',
      show_password: 'Pokaži geslo',
      hide_password: 'Skrij geslo',
      sign_in_error: 'Prijava ni uspela, poskusite znova.',
      logout: 'Odjava',
    },
    notification: {
      updated: 'Element je posodobljen |||| Posodobljenih elementov: %{smart_count}',
      created: 'Element je ustvarjen',
      deleted: 'Element je izbrisan |||| Izbrisanih elementov: %{smart_count}',
      bad_item: 'Napačen element',
      item_doesnt_exist: 'Element ne obstaja',
      http_error: 'Napaka pri povezavi s strežnikom',
      data_provider_error: 'Napaka pri nalaganju podatkov.',
      canceled: 'Dejanje je preklicano',
      logged_out: 'Vaša seja je potekla, prijavite se znova.',
    },
    validation: {
      required: 'Obvezno polje',
      minLength: 'Vnesite vsaj %{min} znakov',
      maxLength: 'Vnesite največ %{max} znakov',
      minValue: 'Vrednost mora biti vsaj %{min}',
      maxValue: 'Vrednost je lahko največ %{max}',
      number: 'Vnesite število',
      email: 'Vnesite veljaven e-poštni naslov',
      oneOf: 'Izberite eno od možnosti: %{options}',
      regex: 'Vrednost mora ustrezati obliki: %{pattern}',
    },
  },
  pos: {
    search: 'Išči',
    profile: 'Profil',
    configuration: 'Nastavitve',
    language: 'Jezik',
    theme: {
      name: 'Tema',
      light: 'Svetla',
      dark: 'Temna'
    },
    dashboard: {
      welcome: {
        title: 'Klima TEAM',
        subtitle: 'Administracija delovnih nalogov.'
      }
    }
  },
  menu: {
    userAdmin: 'Super uporabniki',
    users: 'Uporabniki',
  },
  resources: {
    client: {
      name: 'Odjemalec |||| Odjemalci'
    },
    clients: {
      name: 'Odjemalec |||| Odjemalci'
    },
    subscribers: {
      name: 'Naročnik |||| Naročniki'
    },
    devices: {
      name: 'Naprava |||| Naprave'
    },
    users: {
      name: 'Uporabnik |||| Uporabniki'
    },
    userRole: {
      create: 'Nova uporabniška skupina',
      edit: 'Uredi uporabniško skupino',
      show: 'Uporabniška skupina',
    },
    userRoles: {
      name: 'Uporabniška skupina |||| Uporabniške skupine',
      list: 'Uporabniške skupine',
    },
    projects: {
      name: 'Projekt |||| Projekti'
    },
    panels: {
      name: 'Panel |||| Paneli'
    },
    appUsers: {
      name: 'Monter |||| Monterji'
    },
    addresses: {
      name: 'Naslov |||| Naslovi'
    },
    notifications: {
      name: 'Obvestilo |||| Obvestila'
    },
    orders: {
      name: 'Delovni nalog |||| Delovni nalogi'
    },
    clientCustomers: {
      name: 'Stranka |||| Stranke'
    },
    sessionUsers: {
      name: 'Uporabnik seje |||| Uporabniki sej'
    },
    sessionTypes: {
      name: 'Tip seje |||| Tipi sej'
    },
    settings: {
      name: 'Nastavitev |||| Nastavitve'
    },
    profile: {
      name: 'Profil'
    },

    misc: {
      tabs: {
        userRoleData: 'Podatki skupine',
      },
      fields: {
        userRole: 'Uporabniška skupina',
        username: 'Uporabniško ime',
        firstName: 'Ime',
        lastName: 'Priimek',
        email: 'E-pošta',
        subscribers: 'Naročnik',
        subscriber: 'Naročnik',
        client: 'Odjemalec',
        buildYear: 'Leto izdelave',
        power: 'Moč',
        manufacturer: 'Znamka',
        model: 'Model',
        workers: 'Ekipa',
        password: 'Geslo',
        password2: 'Ponovi geslo',
        active: 'Aktiven',
        pinned: 'Pripeto',
        vat: 'Davčna št.',
        permissions: 'Dovoljenja',
        name: 'Ime',
        search: 'Išči',
        icon: 'Ikona',
        banner: 'Pasica',
        description: 'Opis',
        locked: 'Zaklenjeno',
        enabled: 'Omogočeno',
        content: 'Vsebina',
        title: 'Naslov',
        macAddress: 'MAC',
        orderNumber: 'Št. naročila',
        quantity: 'Količina',
        birthday: 'Datum rojstva',
        createdAt: 'Ustvarjeno',
        height: 'Višina',
        skintype: 'Tip kože',
        weight: 'Teža',
        points: 'Točke',
        calibration: 'Kalibracija',
        city: 'Kraj',
        street: 'Ulica',
        country: 'Država',
        zip: 'Pošta',
        userId: 'ID uporabnika',
        sessionType: 'Tip seje',
        updatedAt: 'Posodobljeno',
        length: 'Dolžina',
        score: 'Rezultat',
        header: 'Glava',
        no: 'Ne',
        yes: 'Da',
        good: 'Dobra',
        cleaningFiltersSpatulasMasks: 'Čiščenje filtrov, loputk in mask',
        desinfectionController: 'Dezinfekcija upravljalnika N.E.',
        testCondention: 'Test kondenčne povezave',
        checkCleaningEvaporator: 'Pregled oz. čiščenje uparjalnika Z.E.',
        breathMeasurement: 'Meritev vpiha (°C)',
        pressureMeasurement: 'Meritev tlaka (bar)',
        ratingZd: 'Ocena vzdrževanja',
        gas: 'Hladivo',
        id: 'ID',
        tightness: 'Tesnost',
        cleanliness: 'Čistost',
        maraeble: 'Zadovoljiva',
        bad: 'Slaba',
        body: 'Vsebina',
        creator: 'Avtor',
        contractor: 'Izvajalec',
        sessionUserId: 'ID uporabnika seje',
        postImage: 'Slika objave',
        likeId: 'ID všečka',
        commentId: 'ID komentarja',
        device: 'Naprava',
        serialNumber: 'Serijska številka',
        parentId: 'Nadrejeni ID',
        followId: 'ID sledenja',
        type: 'Tip',
        typeId: 'Tip',
        notification_read: 'Prebrano',
        deleted: 'Izbrisano',
        link: 'Povezava',
        videoId: 'ID videa',
        membership: 'Članstvo',
        manual: 'Navodila',
        endInstallationDate: 'Konec montaže',
        notes1: 'Opomba 1',
        notes2: 'Opomba 2',
        customerComment: 'Opomba stranke',
        additionalDesc: 'Dodatne opombe',
        orderDate: 'Datum naročila',
        startInstallationDate: 'Začetek montaže',
        status: 'Status',
        customer: 'Stranka',
        address: 'Naslov',
        phonenumber: 'Telefon',
        cName: 'Stranka',
        worker: 'Delavec',
        FIELD_IS_REQUIRED: 'Obvezno polje',
        Admin: 'Administrator',
        appUser: 'Monter',
        clientCustomer: 'Stranka',
        companyName: 'Podjetje',
        material: 'Material',
        orderDevices: 'Naprave',
        s1: 'Vrednost 1',
        s2: 'Vrednost 2',
        s3: 'Vrednost 3',
      },
      userRoleCategories: {
        cat_ADMINISTRATION: 'Administracija',
        cat_OTHER: 'Drugo'
      }
    }
  },
  ROLE_ADMIN: 'Administrator',
  ROLE_CLIENT_ADMIN: 'Administrator odjemalca',
  IS_ADMIN: 'Je administrator',
  PW_MIN_6_MAX_128_1_UPPER_1_LOWER_1_NUMERIC: 'Geslo mora vsebovati: 6 črk, 1 veliko, 1 malo in 1 številko',
  PW_MUST_MATCH: 'Gesli se morata ujemati',
  EMAIL_FORMAT: 'Vnesite veljaven e-poštni naslov',
  FIELD_MUST_HAVE_AT_LEAST_2_CHARACTERS: 'Vnesite vsaj 2 znaka',
  FIELD_IS_NULL: 'Polje je prazno',
  FIELD_IS_REQUIRED: 'Obvezno polje',
  ERROR: {
    ERROR: 'Sistemska napaka.',
    MONTER_HAS_ORDERS: 'Monterja ni mogoče izbrisati, ker ima naročila. Namesto tega ga označi kot neaktivnega.',
    MONTER_HAS_NOTIFICATIONS: 'Monterja ni mogoče izbrisati, ker ima obvestila. Namesto tega ga označi kot neaktivnega.',
    CUSTOMER_HAS_ORDERS: 'Stranke ni mogoče izbrisati, ker ima naročila.',
    SUBSCRIBER_HAS_ORDERS: 'Naročnika ni mogoče izbrisati, ker ima naročila.',
    DEVICE_IN_USE: 'Naprave ni mogoče izbrisati, ker je uporabljena v naročilih.',
    RECORD_IN_USE: 'Zapisa ni mogoče izbrisati, ker je še v uporabi.',
    FIELD_IS_REQUIRED: 'Obvezno polje',
    FIELD_IS_NULL: 'Polje je prazno',
  }
}
